import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Scale, Shield, FileText } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50/50">
      {/* Hero Section */}
      <section className="relative pt-48 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute top-20 right-10 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 left-10 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-blue-900 mb-6">
              Impressum
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-700 mx-auto"></div>
          </div>

          {/* Company Information */}
          <Card className="border-blue-100 bg-white/80 backdrop-blur-sm shadow-xl mb-8">
            <CardContent className="pt-8 pb-8">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <FileText className="text-white" size={24} />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-blue-900 mb-4">Vivalo GmbH</h2>
                  <div className="space-y-2 text-slate-700">
                    <p>Chaltenbodenstrasse 26</p>
                    <p>8834 Schindellegi</p>
                    <p>Schweiz</p>
                    <p className="pt-2"><strong>Telefon:</strong> <a href="tel:+41416776767" className="text-blue-600 hover:text-blue-700">041 677 67 67</a></p>
                    <p><strong>E-Mail:</strong> <a href="mailto:info@vivalo.ch" className="text-blue-600 hover:text-blue-700">info@vivalo.ch</a></p>
                    <p><strong>Webseite:</strong> <a href="https://www.vivalo.ch" className="text-blue-600 hover:text-blue-700">www.vivalo.ch</a></p>
                    <p className="pt-2"><strong>Rechtsform:</strong> Gesellschaft mit beschränkter Haftung (GmbH)</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Management */}
          <Card className="border-blue-100 bg-white/80 backdrop-blur-sm shadow-xl mb-8">
            <CardContent className="pt-8 pb-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Shield className="text-white" size={24} />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-blue-900 mb-4">Geschäftsführung</h2>
                  <p className="text-slate-700">Herr Marlon Traber</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Regulatory Information */}
          <Card className="border-blue-100 bg-white/80 backdrop-blur-sm shadow-xl mb-8">
            <CardContent className="pt-8 pb-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Scale className="text-white" size={24} />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-blue-900 mb-4">Aufsichtsrechtliche Informationen</h2>
                  <p className="text-slate-700">
                    Vivalo GmbH ist als Versicherungsvermittler gemäss Schweizer Versicherungsaufsichtsgesetz (VAG) tätig und im Vermittler-Register der FINMA eingetragen.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Disclaimer */}
          <Card className="border-blue-100 bg-white/80 backdrop-blur-sm shadow-xl mb-8">
            <CardContent className="pt-8 pb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">Haftungsausschluss (Disclaimer)</h2>
              <div className="space-y-4 text-slate-700">
                <p>
                  Die Inhalte dieser Website werden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Informationen übernimmt die Vivalo GmbH jedoch keine Gewähr. Alle Inhalte dienen ausschliesslich allgemeinen Informationszwecken und stellen keine verbindliche Beratung dar.
                </p>
                <h3 className="font-semibold text-blue-900 pt-2">Haftung für Links</h3>
                <p>
                  Verlinkte externe Inhalte liegen ausserhalb unseres Verantwortungsbereichs. Für den Inhalt verlinkter Seiten sind ausschliesslich deren Betreiber verantwortlich.
                </p>
                <h3 className="font-semibold text-blue-900 pt-2">Urheberrecht</h3>
                <p>
                  Alle auf dieser Website veröffentlichten Inhalte, Texte, Grafiken und Bilder unterliegen dem Urheberrecht der Vivalo GmbH oder lizenzierter Dritter. Jede Verwendung ohne schriftliche Zustimmung ist untersagt.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default ImpressumPage;